import React from "react";
import { ReportRule } from "./ReportRule";

export function ReportNotesSection({
  notes,
  variant = "print",
  title = "Notes",
}) {
  if (!notes) return null;

  const isPrint = variant === "print";
  const titleClassName = isPrint ? "erp-section-title" : "er-section-title";

  const content = (
    <>
      <ReportRule variant={variant} />
      <h2 className={titleClassName}>{title}</h2>
      <p className={isPrint ? "erp-notes" : "er-notes"}>{notes}</p>
    </>
  );

  if (isPrint) {
    return <section className="erp-section erp-break-avoid">{content}</section>;
  }

  return content;
}
